module.exports = __webpack_public_path__ + "style/img/developWork.60bcfcc6.png";